<template>
  <div :class="classes()">
    <Button
      type="outlined"
      iconName="subtract-line"
      @click="decrement"
      :disabled="value === 1"
      :class="`${el}__button`"
    />
    <div :class="`${el}__input`">{{ value }}x</div>
    <Button type="outlined" iconName="add-line" @click="increment" :class="`${el}__button`" />
  </div>
</template>

<script>
import Button from '@/objects/Button';

export default {
  name: 'InputCounter',
  props: {
    defaultValue: {
      type: Number,
      required: true,
      default: 1,
    },
    background: {
      type: String,
      default: 'secondaryMint',
      validator: (val) => ['secondaryMint', 'transparent'].includes(val),
    },
  },
  components: {
    Button,
  },
  data() {
    return {
      value: this.defaultValue,
      el: 'o-inputCounter',
      classes: () => {
        const el = this.el;
        return {
          [el]: true,
          [`${el}--${this.background}`]: true,
        };
      },
    };
  },
  watch: {
    value() {
      this.$emit('change', this.value);
    },
  },
  methods: {
    increment() {
      this.value += 1;
    },
    decrement() {
      if (this.value > 1) {
        this.value -= 1;
      }
    },
  },
};
</script>
